import { useAppSelector } from "@/common/hooks";

export const useUnits = () => {
  return useAppSelector((state) => state.appConfig.unit.units);
};

export const useUnitById = () => {
  return useAppSelector((state) => state.appConfig.unit.unitById);
};

export const useRosterUnits = () => {
  return useAppSelector((state) => state.appConfig.unit.rosterUnits);
};

export const useRosterUnitById = () => {
  return useAppSelector((state) => state.appConfig.unit.rosterUnitById);
};
